export default __webpack_public_path__ + "static/media/venue.1ad16773.svg";